<template>
  <div>
    <div class="top_bar">
      <span>{{ currentDate }}</span>
      <span class="week_info">{{ currentDayOfWeek }}</span>
      <span class="ver_line"></span>
      <span class="quit_btn" @click="logOut">退出</span>
      <span class="ver_line"></span>
      <span class="uname_btn">{{ userName }}</span>
    </div>
    <div class="top_bar_next">
      <img src="../assets/logo.png" class="inlogo" />
      <div class="top_in_bar_txt">
        <span class="top_name">开源知识管理工具</span>
        <span class="top_name_eng">KNOWLEDGE SHARING PLATFORM</span>
      </div>
    </div>
    <div class="main_con">
      <div class="main_con_left">
        <el-menu
          default-active="artcol"
          background-color="#2683BE"
          style="height: 100% !important"
          text-color="#fff"
          :router="rt"
          active-text-color="#ffd04b"
        >
          <el-menu-item
            index="artcol"
            style="border-bottom: solid 1px white; text-align: center"
          >
            <i class="el-icon-document"></i>
            <span slot="title" style="font-size: 18px">文章收藏</span>
          </el-menu-item>
          <el-menu-item
            index="artup"
            style="border-bottom: solid 1px white; text-align: center"
          >
            <i class="el-icon-upload2"></i>
            <span slot="title" style="font-size: 18px">文章上传</span>
          </el-menu-item>
          <el-menu-item
            index="me"
            style="border-bottom: solid 1px white; text-align: center"
          >
            <i class="el-icon-user"></i>
            <span slot="title" style="font-size: 18px">个人中心</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="main_right">
        <router-view></router-view>
      </div>
    </div>
    <el-button plain @click="open1"> 消息 </el-button>
    <el-button plain @click="open2"> 消息 </el-button>
    <el-button plain @click="open3"> 消息 </el-button>
  </div>
</template>
<script>
import { getTmpChatList } from "@/api/chat";
export default {
  name: "home",
  data() {
    return {
      rt: true,
      currentDate: "",
      currentDayOfWeek: "",
      userId: 1,
      userName: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    msgContent() {
      return this.$store.getters.msgContent;
    },
  },
  mounted() {
    console.log("home page mounted");
    this.updateDateAndDayOfWeek();
    const { isShareMode } = this.$route.query;
    if (isShareMode) {
      return;
    }
    this.$store.dispatch("WhoAmI").then((res) => {
      this.userId = res.id;
      this.userName = res.name;
    });
    this.open3();
    if (this.$store.state.msgContent.chat.length == 0) {
      this.getChatList();
    } else {
      this.open2();
    }
  },
  methods: {
    menuSelect(index, indexPath) {
      console.log(index);
      console.log(indexPath);
    },
    updateDateAndDayOfWeek() {
      const now = new Date();
      const options = { year: "numeric", month: "long", day: "numeric" };

      // 使用 Intl.DateTimeFormat 格式化日期和星期
      this.currentDate = now.toLocaleDateString("zh-CN", options);
      this.currentDayOfWeek = now.toLocaleDateString("zh-CN", {
        weekday: "long",
      });
      console.log(this.currentDate);
      console.log(this.currentDayOfWeek);
    },
    logOut() {
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push({ name: "login", params: { refresh: true } });
      });
    },
    open1(count) {
      if (count != 0) {
        this.$notify.info({
          title: "消息提示",
          message: "您有" + count + "条消息未读",
        });
      }
    },

    open2() {
      var chat = this.msgContent.chat;
      var count = 0;
      for (var i = 0; i < chat.length; i++) {
        count += chat[i].unreadMessages;
        console.log(chat[i]);
        console.log(chat[i].unreadMessages);
      }
      if (count != 0) {
        this.$notify.info({
          title: "消息提示",
          message: "您有" + count + "条消息未读",
        });
      }
    },

    open3() {
      console.log(this.msgContent.isNotify);
      if (this.msgContent.isNotify) {
        this.$store.dispatch("setIsNotify", false);
        this.$notify.info({
          title: "消息提示",
          message: "您接受到了一条新的消息，请及时查看",
        });
      }
      setTimeout(() => {
        this.open3();
      }, 1000);
    },
    getChatList() {
      var that = this;
      getTmpChatList({ userId: this.userId })
        .then((response) => {
          console.log("getTmpChatList", response.data);
          var count = 0;
          for (var i = 0; i < response.data.length; i++) {
            count += response.data[i].unreadMessages;
          }
          this.open1(count);
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        });
    },
  },
};
</script>

<style>
.main_right {
  flex-grow: 2;
  padding: 20px;
  overflow-y: auto;
}

.main_con_left {
  width: 220px;
}

.main_con {
  background-color: #fdfcfc;
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 0;
  top: 122px;
  display: flex;
}

.top_in_bar_txt {
  margin-left: 30px;
}

.top_name_eng {
  display: block;
  color: white;
  opacity: 0.9;
  font-size: 12px;
  margin-top: 6px;
}

.top_name {
  font-size: 30px;
  color: white;
}

.inlogo {
  width: 55px;
}

.top_bar_next {
  background-image: url("../assets/top_bar_bg.png");
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  height: 60px;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.uname_btn {
  margin-left: 10px;
  cursor: pointer;
}

.quit_btn {
  margin-left: 10px;
  cursor: pointer;
}

.ver_line {
  margin-left: 10px;
  border-right: 2px solid #e5f0f7;
  display: inline-block;
  height: 20px;
}

.week_info {
  margin-left: 15px;
}

.top_bar {
  background-color: #007ec3;
  color: #e5f0f7;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 120px;
}
</style>
